import { RoomCount } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const ROOM_COUNTS = [
  {
    title: '1개',
    value: RoomCount.One,
  },
  {
    title: '2개',
    value: RoomCount.Two,
  },
  {
    title: '3개 이상',
    value: RoomCount.ThreePlus,
  },
]

type Props = {
  className?: string
}

export const RoomCounts = ({ className }: Props) => {
  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { roomCounts },
    updateFilter,
  } = useFilter()

  const handleRoomCountChange = (value: RoomCount) => () => {
    updateFilter({ roomCounts: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.RoomCounts, element)
        }
      }}
    >
      <Title>방 개수</Title>
      <List>
        {ROOM_COUNTS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={roomCounts.includes(value)}
            onClick={handleRoomCountChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
